<div class="product-preview-wrapper" [class.empty]="!loadedImageUrl">
  <div *ngIf="isLoading$ | async" class="ui loader active"></div>
  <img *ngIf="loadedImageUrl" src="{{ loadedImageUrl }}" alt="" loading="eager" />
</div>
